import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { DxDataGridComponent } from 'devextreme-angular';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { MasterDataEditService } from '../../../../../api/master-data-edit.service';
import { AffectingMasterBrandData } from '../../../../../shared/models/product.model';

@Component({
  selector: 'app-rename-master-brand',
  templateUrl: './rename-master-brand.component.html',
})
export class RenameMasterBrandComponent implements OnInit {
  @ViewChild('existingMasterBrandNameGrid') existingMasterBrandNameGrid: DxDataGridComponent;

  public affectedEditMasterBrandNameData: AffectingMasterBrandData[] = [];
  public existingEditMasterBrandNameData: AffectingMasterBrandData[] = [];

  @Input() selectedEditMasterBrandOldName: string;
  @Input() selectedEditMasterBrandNewName: string;
  @Input() masterBrandId;

  private _destroyed$ = new Subject();

  constructor(private masterDataEditService: MasterDataEditService, public activeModal: NgbActiveModal) { }

  ngOnInit() {
	this.masterDataEditService.getAffectingMasterBrandData(this.selectedEditMasterBrandOldName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingMasterBrandData[]) => {
		this.affectedEditMasterBrandNameData = res;
		});

	this.masterDataEditService.getExistingMasterBrandData(this.selectedEditMasterBrandNewName)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingMasterBrandData[]) => {
		this.existingEditMasterBrandNameData = res;
		});
  }

  rename() {
	this.activeModal.close('save');
  }

  customizeMasterBrandId(cellInfo) {
	const idStr = 'MBR_000000';
	const cellValue = String(cellInfo.value);
	const index = idStr.length - cellValue.length;
	const finalText = idStr.slice(0, index) + cellValue;
	return finalText;
  }

  valueChanged(event) {
	this.existingMasterBrandNameGrid.instance.beginCustomLoading('Loading');
	this.masterDataEditService.getExistingMasterBrandData(event.value)
		.pipe(takeUntil(this._destroyed$))
		.subscribe((res: AffectingMasterBrandData[]) => {
		this.existingEditMasterBrandNameData = res;
		this.existingMasterBrandNameGrid.instance.option('dataSource', res);
		this.existingMasterBrandNameGrid.instance.endCustomLoading();
		});
  }
}
